<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm thương hiệu</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Tên" placeholder="Nhập tên" [formGroup]="searchForm" formControlName="nameLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="brandStatusOptionList"></app-input-select>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchBrand()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Tên</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="insertBrand()">Thêm</button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="devBrandList && !loading">
                <tr *ngFor="let devBrand of devBrandList;index as devBrandIndex">
                    <td scope="col">{{(devBrandPagination.currentPage-1)*devBrandPagination.pageSize + devBrandIndex+1}}</td>
                    <td scope="col">{{devBrand.name}}</td>
                    <td scope="col">{{brandStatusOptionMap[devBrand.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewBrand(devBrand)">Xem</button>
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="editBrand(devBrand)">Sửa</button>
                            <button type="button" class="btn btn-danger" *ngIf="hasEditPerm"  (click)="deleteBrand(devBrand)">Xóa</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="devBrandPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':devBrandPagination.currentPage == 1}">
                      <a class="page-link" (click)="devBrandPageChange(devBrandPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="devBrandPagination.currentPage > 3">
                      <a class="page-link" (click)="devBrandPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="devBrandPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of devBrandPagination.pageList"  [ngClass]="{'active':devBrandPagination.currentPage == page}">
                    <a class="page-link" (click)="devBrandPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="devBrandPagination.currentPage < devBrandPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="devBrandPagination.currentPage < devBrandPagination.pageCount - 2">
                    <a class="page-link" (click)="devBrandPageChange(devBrandPagination.pageCount)">{{devBrandPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':devBrandPagination.currentPage == devBrandPagination.pageCount}">
                    <a class="page-link"  (click)="devBrandPageChange(devBrandPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>

